import { Keyword, ThreatCoachIndicator } from "../types/threatCoach";

export const transformThreatCoachIndicatorsToKeywords = (
  indicators: ThreatCoachIndicator[],
): Keyword[] => {
  return indicators.reduce((acc: Keyword[], indicator) => {
    const keywords = indicator.keywords.map((keyword) => {
      return {
        text: keyword,
        colorClass: indicator.colorClass.replace("tw-bg-", ""),
        tag: indicator.tag,
      };
    });

    return [...acc, ...keywords];
  }, []);
};
